import {View} from 'backbone';
import listService from 'ListService.js';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import StageAndRoleSettingsModal from 'common-views/StageAndRoleSettingsModal.js';
import settingsService from 'MandatoryAndStateSettingsService.js';

import _Template from 'properties/accessibility/role-state.ejs';
import _Template2 from 'properties/accessibility/state.ejs';
import util         from 'util/Util.js';

class ColumnAccessStateView extends View {

  initialize(opts) {
    this.options = opts || {};
    this.template = _Template;
    this.tagName = 'div';
    this.colId = this.model.get('selectedRowId');

    this.options = constants.FLASH_STATE_OPTIONS;
    const reducedOptions2 = ['childFormColumn','checkboxColumn','radioButtonColumn','buttonColumn'];    
    const stateptions = ['timeInputColumn','textInputColumn','textAreaColumn','numericInputColumn','fileAttachmentColumn','dropdownColumn','dateInputColumn'];


      if(this.colId){
          let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
          util.updateHelpDocumentationLink(factorykey);
      }
      if(this.model.get('gridData').length > 0){
      if (reducedOptions2.indexOf(this.model.get('gridData')[this.colId].attributes['factoryKey'])!== -1) {
            this.options = constants.REDUCED_STATE_OPTIONS2;
        }

      if (stateptions.indexOf(this.model.get('gridData')[this.colId].attributes['factoryKey'])!== -1) {
            this.options = constants.STATE_OPTIONS;
        }
        
    }

    if(!this.model.has('state')){
            this.model.set('state', new Map(), {silent: true});
        }
    if (!this.model.get('gridData')[this.colId].attributes['state']) {
      this.model.get('gridData')[this.colId].attributes.state = new Map();
    }
    

    this.initValues();

    this.events = {
      'change #propState': 'updateSelectAttributes',
      'click #browseState': 'displaySelectModal'
    };

    this.listenTo(this.model, 'change', this.render);

    this.listenTo(eventBus, constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED, ()=>{
      this.initValues();
      this.render();
    });

    return this;
  }

  initValues() {
    this.role = listService.getCurrentRole();
    this.stage = listService.getCurrentStage();
  }

  displaySelectModal(ev){
    ev.preventDefault();
    const config = {
      settings: this.model.get('gridData')[this.colId].attributes.state,
      model: this.model,
      options:this.options,
      propertyName:"value",
      defaultValue:"default",
      title: "Edit State"
    };
    const alertView = new StageAndRoleSettingsModal(config);
    alertView.render();
  }


  updateSelectAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.value;

      this.model.get('gridData')[this.colId].attributes.stateDisplay = propVal;
    const settings =  this.model.get('gridData')[this.colId].attributes[propName];
    
    if(propVal !== this.getControlSettings()){
      const newSetting = settingsService.createSetting(listService.getCurrentStage(), listService.getCurrentRole(), 'value', propVal);
      settings.set(this.getCurrentKey(), newSetting);
      this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
    }
    this.model.trigger('change');
    // PF-1404: This needs to fire manually, since the "settings" variable above holds a reference to the model's property girdData and won't detect the change made
    // avoiding the model from triggering the change event
    this.model.trigger('change:gridData');
  }

  getViewValues() {
    return {title: this.getViewTitle(), currentState: this.getCurrentState(), options: this.options};
  }

  getViewTitle() {
    let title = 'State';
    const role = listService.getWorkflowRole(this.role);
    const stage = listService.getWorkflowStage(this.stage);

    if (role && stage) {
      title += ' (' + stage.model.get('name') + ' - ' + role.name + ')';
    } else if (role) {
      title += ' (' + role.name + ')';
    } else if (stage) {
      title += ' (' + stage.model.get('name') + ')';
    }

    return title;

  }

  getCurrentKey(){
    return listService.getCurrentStage() + '_' + listService.getCurrentRole();
  }

  getCurrentState() {
      const state = this.model.get('gridData')[this.colId].attributes['state'];
      let currentValue = {value: 'default'};
      const allCurrentStage = this.stage + '_all';
      const allCurrentRole = 'all_' + this.role;
      const all = 'all_all';

      if (state.has(this.getCurrentKey())) {
        currentValue = state.get(this.getCurrentKey());
      } else if (state.has(allCurrentStage)) {
        currentValue = state.get(allCurrentStage);
      } else if (state.has(allCurrentRole)) {
        currentValue = state.get(allCurrentRole);
      } else if (state.has(all)) {
        currentValue = state.get(all);
      }

      this.model.get('gridData')[this.colId].attributes.stateDisplay=currentValue.value;
      return currentValue;
  }

  getControlSettings(){
    const
        options = {
          stageId: listService.getCurrentStage(),
          roleId: listService.getCurrentRole(),
          settings: this.model.get('gridData')[this.colId].attributes.state,
          defaultValue: "default",
          settingsField: "value"
        };

    return settingsService.getSetting(options);
  }


  render() {
    if (this.getViewTitle() === 'State') {
        this.template = _Template2;
    }

    this.$el.empty();
    if (this.template) {
      this.$el.html(this.template(this.getViewValues()));
    }

    this.delegateEvents();
    return this;
  }

  remove() {
    this.$el.empty();
    this.undelegateEvents();
    this.stopListening();

    super.remove();
  }

}

export default ColumnAccessStateView;
